import { render } from "./Order_print.vue?vue&type=template&id=b4bb02c6&ts=true"
import script from "./Order_print.vue?vue&type=script&lang=ts"
export * from "./Order_print.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__